import React from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { EMPTY_ARRAY_LENGTH } from "../../../constants";

const SINGLE_QUESTION_LENGTH = EMPTY_ARRAY_LENGTH + 1;

/**
 * Preview Survey button, or dropdown (Normal / NPS First) when NPS First is partial.
 */
const PreviewSurveyControls = ({
  isNpsFirstPartialActivated,
  isNpsFirstFullyActivated,
  previewDropdownOpen,
  setPreviewDropdownOpen,
  questionListLength,
  onPreviewSurvey,
}) => {
  const isDisabled = questionListLength === SINGLE_QUESTION_LENGTH;

  if (isNpsFirstPartialActivated) {
    return (
      <Dropdown
        isOpen={previewDropdownOpen}
        toggle={() => setPreviewDropdownOpen((prev) => !prev)}
        disabled={isDisabled}
      >
        <DropdownToggle
          caret
          className="preview-survey-button"
          disabled={isDisabled}
        >
          Preview Survey
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={(e) => onPreviewSurvey(e, false)}>
            Normal Survey
          </DropdownItem>
          <DropdownItem onClick={(e) => onPreviewSurvey(e, true)}>
            NPS First Survey
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  }

  return (
    <button
      className="preview-survey-button"
      onClick={(e) => onPreviewSurvey(e, isNpsFirstFullyActivated)}
      disabled={isDisabled}
    >
      Preview Survey
    </button>
  );
};

PreviewSurveyControls.propTypes = {
  isNpsFirstPartialActivated: PropTypes.bool,
  isNpsFirstFullyActivated: PropTypes.bool,
  previewDropdownOpen: PropTypes.bool,
  setPreviewDropdownOpen: PropTypes.func.isRequired,
  questionListLength: PropTypes.number,
  onPreviewSurvey: PropTypes.func.isRequired,
};

export default PreviewSurveyControls;
